import {
  format,
  parseISO,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subQuarters,
  subWeeks,
  subYears,
} from "date-fns";

const ROLLING_TO_DATE_PERIOD_FNS = {
  ROLLING_DAYS_TO_DATE: { startOf: startOfDay, sub: subDays },
  ROLLING_WEEKS_TO_DATE: { startOf: startOfWeek, sub: subWeeks },
  ROLLING_MONTHS_TO_DATE: { startOf: startOfMonth, sub: subMonths },
  ROLLING_QUARTERS_TO_DATE: { startOf: startOfQuarter, sub: subQuarters },
  ROLLING_YEARS_TO_DATE: { startOf: startOfYear, sub: subYears },
};

export const ROLLING_TO_DATE_TYPES = new Set(
  Object.keys(ROLLING_TO_DATE_PERIOD_FNS)
);

export function isRollingToDateType(toDateType) {
  return ROLLING_TO_DATE_TYPES.has(toDateType);
}

export function computeRollingToDateRange(
  toDateType,
  count,
  endDateString,
  dateFormat = "yyyy-MM-dd"
) {
  const periodFns = ROLLING_TO_DATE_PERIOD_FNS[toDateType];

  if (!periodFns || !endDateString) {
    return {};
  }

  const normalizedCount = Number.isInteger(count) ? count : 1;
  const endDate = parseISO(endDateString);
  const { startOf, sub } = periodFns;

  return {
    from: format(startOf(sub(endDate, normalizedCount - 1)), dateFormat),
    to: format(endDate, dateFormat),
  };
}
